define('models/calendar/personal-data/personal-data-type',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
    'services/user',
    'services/i18n',
], function(_, Backbone, U, API, User, i18n) {

    var MPersonalDataType = Backbone.Model.extend({
        idAttribute: '_id',
        lengthUnits: 'cm / in',
        distanceUnits: 'km / mi',
        weightUnits: 'lbs / kg',
        waistlineId: '5c533ec334cb55460b4d3c4b',
        weightId: '5c533ee234cb55460b4d3c4c',
        urlRoot: API.url("custom-datas/"),
        defaults: {
            name: "",
            description: "",
            unit: "",
            memberEntry: true,
            sumEntry: 0,
            group: "",
            global: false
        },

        getUnit: function() {
            return this.get('unit');
        },

        getTranslatedUnit: function() {
            return this.isConvertible() ? i18n.t(this.get('unit')) : this.get('unit');
        },

        getUserUnit: function() {
            switch (this.getUnit()) {
                case this.lengthUnits: return User.get('lengthUnit');
                case this.weightUnits: return User.get('weightUnit');
                case this.distanceUnits: return User.get('distanceUnit');
                default: return this.getUnit();
            }
        },

        isConvertible: function() {
            return this.getUnit() === this.lengthUnits || this.getUnit() === this.weightUnits || this.getUnit() === this.distanceUnits;
        },

        getCurrentValueComputeTypes: function() {
            return [
                { label: 'goal:the last calendar entry', value: '0' },
                { label: 'goal:the sum of the calendar entry', value: '1' },
            ];
            // return new Backbone.Collection([
            //     { label: 'goal:the last calendar entry', value: '0' },
            //     { label: 'goal:the sum of the calendar entry', value: '1' }
            // ]);
        },
    });

    // Return the model for the module
    return MPersonalDataType;
});

